import Grid from '@material-ui/core/Grid'
import React, { FC, useRef, useState } from 'react'
import { VerticalTabContainer } from './style'

//* utils
import Path from '../../../../static/steam-img/Path.svg'
import { ComponentSlider } from '../../../models/components/slider'

//* components
import GlobalContainer from '../globalContainer'
import WrapperImage from '../wrapperImage'
import { VerticalContent } from './subcomponents/verticalContent'
import { VerticalMenu } from './subcomponents/verticalMenu'

type Props = {
  data: ComponentSlider
}

const VerticalTab: FC<Props> = ({ data }) => {
  if (!data || !data?.panels?.length) return null
  const verticalTabData = {
    panels: data.panels || [],
    topPadding: data.topPadding || 'None',
    bottomPadding: data.bottomPadding || 'None',
  }

  const [slideNumber, setSlideNumber] = useState(0)
  const customSlider = useRef<HTMLDivElement>()
  const tabs = useRef<HTMLUListElement>()

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    swipe: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (current: number, next: number) => {
      if (tabs && tabs.current && tabs.current.children) {
        tabs.current.children[slideNumber] &&
          tabs.current.children[slideNumber].classList.remove('VerticalTabs__Active--Desktop')

        tabs.current.children[slideNumber] &&
          tabs.current.children[next].classList.add('VerticalTabs__Active--Desktop')
      }

      setSlideNumber(next)
    },
  }

  const goToSlide = (idx: number) => {
    let screenSize = window.matchMedia('(max-width: 1024px)')
    if (screenSize.matches && tabs.current && tabs.current.children && tabs.current.children[idx]) {
      //* For Accordion Tab
      if (tabs.current.children[idx].classList.contains('VerticalTabs__Active--Mobile'))
        tabs.current.children[idx].classList.remove('VerticalTabs__Active--Mobile')
      else tabs.current.children[idx].classList.add('VerticalTabs__Active--Mobile')
    } else if (typeof customSlider !== undefined && customSlider.current) {
      // @ts-ignore
      customSlider.current.slickGoTo(idx)
    }
  }

  return (
    <VerticalTabContainer
      $topPadding={verticalTabData.topPadding}
      $bottomPadding={verticalTabData.bottomPadding}
      data-cy="VerticalTab">
      <GlobalContainer>
        <Grid className="VerticalTabs__Grid-Container" container spacing={2}>
          <VerticalMenu verticalTabData={verticalTabData} tabs={tabs} goToSlide={goToSlide} />

          <WrapperImage
            className="VerticalTabs__Mac"
            src={Path}
            alt="mac"
            width={690}
            height={345}
            threshold={650}
          />

          <VerticalContent
            verticalTabData={verticalTabData}
            slideNumber={slideNumber}
            settings={settings}
            customSlider={customSlider}
          />
        </Grid>
      </GlobalContainer>
    </VerticalTabContainer>
  )
}

export default VerticalTab
